export const migrationType = [
  {
    eoi: "Expression of Interest (EOI)",
    eoi_189: "Expression of Interest (EOI) - 189",
    eoi_190: "Expression of Interest (EOI) - 190",
    eoi_491: "Expression of Interest (EOI) - 491",
    noicc: "Notice of Intention to Consider Cancellation (NOICC) of Visa",
    roi: "Registration of Interest (ROI)",
  },
];
export const gstbycountry = [
  {
    title: "AUD",
    value: 10,
  },
  {
    title: "CAD",
    value: 5,
  },
  {
    title: "GBP",
    value: 20,
  },
  {
    title: "MYR",
    value: 10,
  },
  {
    title: "PKR",
    value: 17,
  },
  {
    title: "SGD",
    value: 7,
  },
  {
    title: "USD",
    value: 18,
  },
];
export const visaStatus = [
  {
    title: "Application Approved",
    value: 100,
  },
  {
    title: "Application Lodged",
    value: 3,
  },
  {
    title: "Application Received",
    value: 2,
  },
  {
    title: "Application Refused",
    value: 101,
  },
  {
    title: "Application Withdrawn",
    value: -1,
  },
  {
    title: "Discontinued",
    value: 13,
  },
  {
    title: "Invalid Application",
    value: 12,
  },
  {
    title: "Natural Justice Received",
    value: 6,
  },
  {
    title: "Natural Justice Submitted",
    value: 7,
  },
  {
    title: "Prospect",
    value: 1,
  },
  {
    title: "RFI Received",
    value: 4,
  },
  {
    title: "RFI Submitted",
    value: 5,
  },
  {
    title: "RFI Received & Natural Justice Received",
    value: 8,
  },
  {
    title: "EOI Submitted",
    value: 200,
  },
];
export const rfiStatus = [
  {
    title: "RFI Received",
    value: 4,
  },
  {
    title: "RFI Submitted",
    value: 5,
  },
];
export const njStatus = [
  {
    title: "NJ Received",
    value: 6,
  },
  {
    title: "NJ Submitted",
    value: 7,
  },
];
export const changeVisaStatus = [
  {
    title: "Application Approved",
    value: 100,
  },
  {
    title: "Application Refused",
    value: 101,
  },
  {
    title: "Application Withdrawn",
    value: -1,
  },
  {
    title: "Application Received",
    value: 2,
  },
  {
    title: "Application Lodged",
    value: 3,
  },
  {
    title: "Discontinued",
    value: 13,
  },
  {
    title: "Info Requested",
    value: 9,
  },
  {
    title: "Info Submitted",
    value: 10,
  },
  // {
  //     title   : 'RFI Received',
  //     value   : 4,
  // },
  // {
  //     title   : 'RFI Response Submitted',
  //     value   : 5,
  // },
  // {
  //     title   : 'Natural Justice Received',
  //     value   : 6,
  // },
  // {
  //     title   : 'Natural Justice Response Submitted',
  //     value   : 7,
  // },
  // {
  //     title   : 'RFI / NJ Received',
  //     value   : 8,
  // },
  // {
  //     title   : 'RFI Sub / NJ Rec',
  //     value   : 9,
  // },
  // {
  //     title   : 'RFI Rec / NJ Sub',
  //     value   : 10,
  // },
  // {
  //     title   : 'RFI / NJ Submitted',
  //     value   : 11,
  // },
  {
    title: "Invalid Application",
    value: 12,
  },
  {
    title: "Prospect",
    value: 1,
  },
];
export const noiccStatus = [
  {
    title: "Discontinued",
    value: 13,
  },
  {
    title: "Info Requested",
    value: 4,
  },
  {
    title: "NOICC Received",
    value: 2,
  },
  {
    title: "NOICC Response Submitted",
    value: 3,
  },
  {
    title: "Prospect",
    value: 1,
  },
  {
    title: "RFI Response Submitted",
    value: 5,
  },
  {
    title: "Visa Not Cancelled",
    value: 100,
  },
  {
    title: "Visa Cancelled",
    value: 101,
  },
];
export const eoiStatus = [
  {
    title: "Application Received",
    value: 2,
  },
  {
    title: "Discontinued",
    value: 13,
  },
  {
    title: "EOI Submitted",
    value: 200,
  },
  {
    title: "EOI Expired",
    value: 101,
  },
  {
    title: "Invitation Received",
    value: 100,
  },
  {
    title: "Prospect",
    value: 1,
  },
];
export const roiStatus = [
  {
    title: "Application Received",
    value: 2,
  },
  {
    title: "Discontinued",
    value: 13,
  },
  {
    title: "Invitation Received",
    value: 100,
  },
  {
    title: "Prospect",
    value: 1,
  },
  {
    title: "ROI Submitted",
    value: 3,
  },
  {
    title: "ROI Expired",
    value: 101,
  },
];
export const changeEduStatus = [
  {
    title: "Application Lodged",
    value: 3,
  },
  {
    title: "Application Received",
    value: 2,
  },
  {
    title: "Application Refused",
    value: 101,
  },
  {
    title: "Application Withdrawn",
    value: 0,
  },
  {
    title: "Application Withdrawn",
    value: -100,
  },
  {
    title: "Application Withdrawn",
    value: -3,
  },
  {
    title: "Conditional Offer Received",
    value: 102,
  },
  {
    title: "Deferral Requested",
    value: 109,
  },
  {
    title: "Deferred Offer Letter Received",
    value: 110,
  },
  {
    title: "Discontinued",
    value: 7,
  },
  {
    title: "Full Offer Received - GS Approved",
    value: 6,
  },
  {
    title: "GTE/GS Assessment",
    value: 8,
  },
  {
    title: "Info Requested",
    value: 4,
  },
  {
    title: "Info Submitted",
    value: 5,
  },
  {
    title: "Offer Accepted - COE/CAS/LOA Received",
    value: 9,
  },
  {
    title: "Offer Accepted - Fee Paid",
    value: 100,
  },
  {
    title: "Offer Not Accepted",
    value: 103,
  },
  {
    title: "Prospect",
    value: 1,
  },
  {
    title: "Refund Applied",
    value: 104,
  },
  {
    title: "Refund Paid",
    value: 105,
  },
  {
    title: "Visa Application Submitted",
    value: 106,
  },
  {
    title: "Visa Application Approved",
    value: 107,
  },
  {
    title: "Visa Application Refused",
    value: 108,
  },
];
export const eduStatus = [
  {
    title: "Application Lodged",
    value: 3,
  },
  {
    title: "Application Received",
    value: 2,
  },
  {
    title: "Application Refused",
    value: 101,
  },
  {
    title: "Application Withdrawn",
    value: 0,
  },
  {
    title: "Application Withdrawn",
    value: -100,
  },
  {
    title: "Application Withdrawn",
    value: -3,
  },
  {
    title: "Conditional Offer Received",
    value: 102,
  },
  {
    title: "Deferral Requested",
    value: 109,
  },
  {
    title: "Deferred Offer Letter Received",
    value: 110,
  },
  {
    title: "Discontinued",
    value: 7,
  },
  {
    title: "Full Offer Received - GS Approved",
    value: 6,
  },
  {
    title: "GTE/GS Assessment",
    value: 8,
  },
  {
    title: "Info Requested",
    value: 4,
  },
  {
    title: "Info Submitted",
    value: 5,
  },
  {
    title: "Offer Accepted - Fee Paid",
    value: 100,
  },
  {
    title: "Offer Accepted - COE/CAS/LOA Received",
    value: 9,
  },
  {
    title: "Offer Not Accepted",
    value: 103,
  },
  {
    title: "Prospect",
    value: 1,
  },
  {
    title: "Refund Applied",
    value: 104,
  },
  {
    title: "Refund Paid",
    value: 105,
  },
  {
    title: "Visa Application Approved",
    value: 107,
  },
  {
    title: "Visa Application Refused",
    value: 108,
  },
  {
    title: "Visa Application Submitted",
    value: 106,
  },
];

export const educationStatus = [
  { title: "RFI Sub / NJ Rec", value: 9 },
  { title: "RFI Response Submitted", value: 5 },
  { title: "RFI Rec / NJ Sub", value: 10 },
  { title: "RFI Received", value: 4 },
  { title: "RFI / NJ Submitted", value: 11 },
  { title: "RFI / NJ Received", value: 8 },
  { title: "Refund Paid", value: 105 },
  { title: "Refund Applied", value: 104 },
  { title: "Prospect", value: 1 },
  { title: "Offer Not Accepted", value: 103 },
  { title: "Offer Accepted", value: 100 },
  { title: "Info Submitted", value: 10 },
  { title: "Info Requested", value: 9 },
  { title: "Full Offer Received", value: 6 },
  { title: "Discontinued", value: 7 },
  { title: "Conditional Offer Received", value: 102 },
  { title: "Application Withdrawn", value: 0 },
  { title: "Application Refused", value: 101 },
  { title: "Application Received", value: 2 },
  { title: "Application Lodged", value: 3 },
];

export const migrationStatus = [
  { title: "Application Withdrawn", value: 0 },
  { title: "Application Refused", value: 101 },
  { title: "Application Received", value: 2 },
  { title: "Application Lodged", value: 3 },
  { title: "Application Approved", value: 100 },
  { title: "Discontinued", value: 13 },
  { title: "NJ Response Submitted", value: 7 },
  { title: "NJ Received", value: 6 },
  { title: "NOICC Submitted", value: 15 },
  { title: "NOICC Received", value: 14 },
  { title: "Offer not Accepted", value: 103 },
  { title: "Prospect", value: 1 },
  { title: "RFI Sub / NJ Rec", value: 9 },
  { title: "RFI Rec / NJ Sub", value: 10 },
  { title: "RFI / NJ Submitted", value: 11 },
  { title: "RFI / NJ Received", value: 8 },
  { title: "Invalid Application", value: 12 },
  { title: "Info Submitted", value: 5 },
  { title: "Info Requested", value: 4 },
];
export const reportType = [
  { title: "Course", value: "course" },
  { title: "English Test", value: "ielts" },
  { title: "Health Refund", value: "health" },
  { title: "License", value: "license" },
  { title: "OSHC", value: "oshc" },
  { title: "Passport", value: "passport" },
  { title: "Police Check", value: "police" },
  { title: "Skill  Assessment", value: "skill" },
  { title: "Tution Fee Refund", value: "fee" },
  { title: "Visa", value: "visa" },
];

export const sortBy = [
  {
    title: "Expiry Date",
    value: "expiry",
  },
  {
    title: "User Creation Date",
    value: "create",
  },
];
export const courseSortBy = [
  {
    title: "Start Date",
    value: "startdate",
  },
  {
    title: "End Date",
    value: "enddate",
  },
];
export const paymentStatus = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Paid",
    value: "paid",
  },
  {
    label: "Pending",
    value: "pending",
  },
];
export const commissionSortBy = [
  {
    label: "Due Date",
    value: "duedate",
  },
  {
    label: "Over Due",
    value: "overdue",
  },
];
export const oshcSortBy = [
  {
    title: "Apply oshc",
    value: "apply",
  },
  {
    title: "Oshc Applied",
    value: "applied",
  },
];
export const feeSortby = [
  {
    title: "Apply Fee-Refund",
    value: "apply",
  },
  {
    title: "Fee-Refund Applied",
    value: "applied",
  },
];

export const allSortBy = [
  {
    title: "Expiry Date",
    value: "expiry",
  },
  {
    title: "Issue Date",
    value: "issue",
  },
  {
    title: "User Creation Date",
    value: "create",
  },
];
export const note_type = [
  {
    title: "Call",
    value: 2,
  },
  {
    title: "Case Work",
    value: 7,
  },
  {
    title: "Email Sent",
    value: 4,
  },
  {
    title: "Email Received",
    value: 5,
  },
  {
    title: "In-Person",
    value: 6,
  },
  {
    title: "Skype",
    value: 3,
  },
  {
    title: "Whatsapp",
    value: 1,
  },
  {
    title: "Zoom Consultation",
    value: 8,
  },
];
export const agent_type = [
  {
    title: "Aptitude Office",
    value: 1,
  },
  {
    title: "External Referring Agent",
    value: 2,
  },
  {
    title: "External Processing Agent",
    value: 5,
  },
  {
    title: "External Processing and Referring Agent",
    value: 7,
  },
  {
    title: "Campaign",
    value: 3,
  },
  {
    title: "Others",
    value: 4,
  },
  {
    title: "User",
    value: 8,
  },
  // {
  //     title   : 'External Agent',
  //     value   : 6,
  // },
];
export const app_location = [
  {
    title: "onshore",
  },
  {
    title: "offshore",
  },
];
export const noteFor = [
  {
    title: "Clients",
  },
  {
    title: "Education",
  },
  {
    title: "Migration",
  },
  {
    title: "Providers",
  },
];
export const form_type = [
  {
    title: "Immigration",
  },
  {
    title: "Registration",
  },
];

export const preferred_country = [
  {
    title: "Australia",
  },
  {
    title: "UK",
  },
  {
    title: "USA",
  },
];
export const external_agent_type = [
  {
    title: "Referring",
    value: "referring",
  },
  {
    title: "Processing",
    value: "processing",
  },
];
export const user_role = [
  {
    title: "Admin",
    value: "0",
  },

  {
    title: "Super Admin",
    value: "2",
  },
  {
    title: "User",
    value: "1",
  },
];
export default {
  changeVisaStatus,
  external_agent_type,
  preferred_country,
  commissionSortBy,
  paymentStatus,
  oshcSortBy,
  gstbycountry,
  migrationType,
  visaStatus,
  noiccStatus,
  eoiStatus,
  roiStatus,
  eduStatus,
  educationStatus,
  migrationStatus,
  reportType,
  sortBy,
  courseSortBy,
  allSortBy,
  app_location,
  noteFor,
  user_role,
  rfiStatus,
  njStatus,
  changeEduStatus,
};
